import React from "react";
import styled from "styled-components";

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

interface Props {
  children: React.ReactNode;
}

const TileGridPopup: React.FC<Props> = ({ children }) => {
  return <Grid>{children}</Grid>;
};

export default TileGridPopup;
